import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'

const WhatHappensNow = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={commonStyles.heading}>What happens now?</h1>
      <div className={commonStyles.subheading}>In the following steps you will have the option to register for delivery to Tracklib</div>
      <div className={commonStyles.textContent}>
        <div className={commonStyles.paragraph}>
          In order to do so you will have to sign Tracklib&apos;s licensing agreements, which will be sent to you separately through the
          HelloSign platform
        </div>
        <div className={commonStyles.paragraph}>
          Once signed, your distributor will enable &quot;Tracklib&quot; as a digital service for you to send new releases (and also queue
          back catalogue). You may also deliver any <strong>stems and/or multitracks</strong> you want to Tracklib
        </div>
        <div className={commonStyles.paragraph}>
          If there is any missing information that we need from you for your catalog to go live on Tracklib, we will reach out to you
        </div>
        <div className={commonStyles.paragraph}>
          <strong style={{ color: 'red' }}>
            Please note: We are unable to accept any full tracks that have royalty bearing samples, and we are not able to accept multitrack
            and stems with any samples in
          </strong>
        </div>
      </div>
    </motion.div>
  )
}

export default WhatHappensNow
